import { faListMusic } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { WPPlaylists } from '~/components/organisms/WPPlaylists';

export type IAppWPPlaylistsPageProps = {
  appId: string;
};

export const AppWPPlaylistsPage: React.FC<IAppWPPlaylistsPageProps> = (
  props,
) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppWPPlaylistsPage.seo.title')}</title>
      </Helmet>

      <Heading
        title={t('AppWPPlaylistsPage.title')}
        subtitle={t('AppWPPlaylistsPage.subtitle')}
        icon={<FontAwesomeIcon icon={faListMusic} />}
      />

      <WPPlaylists appId={appId} />
    </>
  );
};
